import { useSelector } from 'react-redux'
import { FormValidation, FormValues } from '../../../types'
import { useTexts } from './useTexts'
import { selectCompanyByNameLowercase } from '@/features/domain/company'

const validateForm =
  (
    texts: ReturnType<typeof useTexts>,
    companiesByName: ReturnType<typeof selectCompanyByNameLowercase>,
  ) =>
  async (formValues: FormValues): Promise<FormValidation> => {
    const { name } = formValues
    const maxLength = 50

    const validation: FormValidation = {}

    if (!name || name.trim().length === 0) {
      validation.name = texts.validation.empty
    } else if (name.length > maxLength) {
      validation.name = texts.validation.maxLength(maxLength)
    } else if (name.toLowerCase() in companiesByName) {
      validation.name = texts.validation.alreadyExists
    }

    return validation
  }

export const useValidateForm = () => {
  const texts = useTexts()
  const companiesByName = useSelector(selectCompanyByNameLowercase)
  return async (formValues: FormValues) => {
    return validateForm(texts, companiesByName)(formValues)
  }
}
